import { render } from "./CmsCreatorTips.vue?vue&type=template&id=3cd10075"
import script from "./CmsCreatorTips.vue?vue&type=script&lang=js"
export * from "./CmsCreatorTips.vue?vue&type=script&lang=js"

import "./CmsCreatorTips.vue?vue&type=style&index=0&id=3cd10075&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__